/* eslint react-hooks/exhaustive-deps: "warn" */
import { useInt } from 'hooks/useInt';

import { Button } from 'ui/atoms/Button/Button';
import { TitleBlock } from 'ui/atoms/TitleBlock/TitleBlock';
import { Section } from 'ui/molecules/Section/Section';

import styles from './TransferPricingFinalCta.module.scss';

export const TransferPricingFinalCta = () => {
  const { t } = useInt();

  return (
    <Section className={styles.section}>
      <div className={styles.card}>
        <span className={styles.accent} aria-hidden="true" />
        <div className={styles.glow} aria-hidden="true" />

        <div className={styles.grid}>
          <div className={styles.copy}>
            <TitleBlock
              align="left"
              className={styles.titleBlock}
              title={t('Send us a set that is about to be challenged.')}
              description={t(
                'Give us the search strategy behind it. We will rebuild the set from registry filings, put every figure next to the document it came from, and show you which comparables drop once ownership is read from the register.',
              )}
            />
          </div>

          <div className={styles.actions}>
            <Button type="blue" size="xl" href="/book-a-demo">
              {t('Book a working session')}
            </Button>

            <Button type="dark-outline" size="xl" href="/free-trial">
              {t('Run a search yourself')}
            </Button>
          </div>
        </div>
      </div>
    </Section>
  );
};
